import { z } from '@simplisafe/ewok'

/**
 * This is for Gatsby's data layer only and can be deleted later.
 */
export const trustPilotSchema = z.object({
  __typename: z.literal('ContentfulWidgetTrustpilotBanner'),
  contentful_id: z.string()
})
